"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
function currentWindowHeight() {
    var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return window.innerHeight - offset;
}
function currentWindowWidth() {
    var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return window.innerWidth - offset;
}
var fitsScreen = function(element) {
    var dimensions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all", offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (dimensions === "all") {
        // Check if the element fits the screen for both width and height
        return element.offsetWidth <= currentWindowWidth(offset) && element.offsetHeight <= currentWindowHeight(offset);
    }
    if (dimensions === "width") {
        // Check if the element fits the screen for width
        return element.offsetWidth <= currentWindowWidth(offset);
    }
    if (dimensions === "height") {
        // Check if the element fits the screen for height
        return element.offsetHeight <= currentWindowHeight(offset);
    }
};
var _default = fitsScreen;
